<highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" class="chart"></highcharts-chart>